/** A fingerprint of a game's state, for the determinism tests and replays (docs/spec/05 R2). */

import { mixSeed } from './rng';
import type { GameState } from './types';

/** Positions to 1/256 of a pixel: anything coarser could hide a drift. */
function q(v: number): number {
  return Math.round(v * 256) | 0;
}

const PHASES = ['intro', 'entering', 'battle', 'challenge', 'tally', 'empress', 'clear', 'gameover'];
const STATUSES = ['flying', 'dead', 'arriving', 'caught'];
const STATES = ['entering', 'homing', 'formed', 'morphing', 'diving', 'hover', 'leaving'];
const KINDS = ['stinger', 'moth', 'monarch', 'captive', 'morph'];

export function hashState(s: GameState): number {
  const p = s.player;
  const pw = s.powers;
  const parts: number[] = [
    s.tick, s.stage, s.score, s.lives, PHASES.indexOf(s.phase), s.phaseT, s.chain, s.chainClock, s.dropMeter,
    s.capturedMsg, q(p.x), STATUSES.indexOf(p.status), p.timer, p.dual ? 1 : 0, Math.min(p.safe, 1000),
    pw.rapid, pw.spread, pw.pierce, pw.chrono, pw.shield ? 1 : 0, pw.novas, s.stats.shots, s.stats.hits,
    s.enemies.length, s.shots.length, s.bombs.length, s.capsules.length,
    q(s.formation.sway), q(s.formation.spread), ...s.rng.save(),
  ];
  for (const e of s.enemies) {
    parts.push(e.id, KINDS.indexOf(e.kind), STATES.indexOf(e.state), q(e.x), q(e.y), q(e.heading), q(e.dist), e.hp, e.timer);
  }
  for (const b of s.bombs) parts.push(q(b.x), q(b.y));
  for (const shot of s.shots) parts.push(q(shot.x), q(shot.y));
  for (const c of s.capsules) parts.push(q(c.x), q(c.y));
  const em = s.empress;
  if (em) parts.push(q(em.x), q(em.y), em.hp, em.phase, em.t, em.attackT, em.turn);
  if (s.beam) parts.push(s.beam.boss, s.beam.t, q(s.beam.reach));
  if (s.rescue) parts.push(q(s.rescue.x), q(s.rescue.y), s.rescue.t);
  return mixSeed(...parts);
}
